import { HttpClient } from "@angular/common/http";
import { Injectable, Inject } from "@angular/core";
import {  ReviewInfo, SubmitResponse } from "../../models";
import { HttpService } from "./http.service";
import { Observable, catchError, of } from "rxjs";

@Injectable({
  providedIn: 'root'
})
export class UploadService extends HttpService<FormData, ReviewInfo> {
  constructor(httpClient: HttpClient, @Inject('API_URL') apiUrl: string, @Inject('API_VERSION') apiVersion: string) {
    super(httpClient, apiUrl, apiVersion, 'upload');
  }

 reviewImage(formData: FormData,modeltype): Observable<SubmitResponse> {
    return this.create(formData,'general?model='+modeltype).pipe(catchError((error) => of(error)));
  }
   uploadTagImage(formData: FormData,modeltype): Observable<SubmitResponse> {
      return this.create(formData, 'general?model='+modeltype).pipe(catchError((error) => of(error)));
    }
    uploadBrandImage(formData: FormData,modeltype): Observable<SubmitResponse> {
      return this.create(formData, 'general?model='+modeltype).pipe(catchError((error) => of(error)));
    }
    uploadCategoryImages(formData: FormData,modeltype): Observable<SubmitResponse> {
      return this.create(formData, 'general?model='+modeltype).pipe(catchError((error) => of(error)));
    }
    uploadMediaBannersImages(formData: FormData,modeltype): Observable<SubmitResponse> {
      return this.create(formData, 'general?model='+modeltype).pipe(catchError((error) => of(error)));
    }
    uploadInfluencerImages(formData: FormData): Observable<SubmitResponse> {
      return this.create(formData, 'general?model=Influencer').pipe(catchError((error) => of(error)));
    }
    // uploadTagImages(formData: FormData): Observable<SubmitResponse> {
    //   return this.create(formData, 'tag').pipe(catchError((error) => of(error)));
    // }
    // uploadBrandImage(formData: FormData): Observable<SubmitResponse> {
    //   const uploadUrl = `${this['url']}/api/${this['version']}/upload/brand`; // Manually build it
    //   return this.httpClient.post<SubmitResponse>(uploadUrl, formData);
    // }
  // productImage(formData:FormData):Observable<>
  

  uploadImages(formData: FormData ): Observable<SubmitResponse> {
    // formData should contain one or multiple files under a key, e.g. 'files'
    return this.create(formData, 'product').pipe(catchError((error) => of(error)));
  }
    uploadAllMedia(formData: FormData): Observable<SubmitResponse> {
    // formData should contain all media files under appropriate keys
    return this.create(formData, 'general?model=Tag').pipe(catchError((error) => of(error)));
  }

  /** Home page section banners — errors must propagate (no catchError swallowing). */
  uploadHomePageSectionMedia(formData: FormData): Observable<SubmitResponse> {
    return this.create(formData, 'general?model=Tag');
  }
     uploadReturnMedia(formData: FormData): Observable<SubmitResponse> {
    // formData should contain all media files under appropriate keys
    return this.create(formData, 'return').pipe(catchError((error) => of(error)));
  }
}
